var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comp-terms"},[_c('text-subpage',{attrs:{"page-type":"termsOfUseCompensation","hide-breadcrumb":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }